export function isFiniteNumber(value: unknown): value is number {
  return typeof value === "number" && Number.isFinite(value);
}

export function assertPositive(
  value: number | undefined,
  path: string,
  issues: string[],
  strict = false,
): void {
  if (value === undefined) {
    return;
  }

  if (!isFiniteNumber(value) || (strict ? value <= 0 : value < 0)) {
    issues.push(
      `${path} must be ${strict ? "greater than" : "greater than or equal to"} 0.`,
    );
  }
}

export function assertFinite(
  value: number | undefined,
  path: string,
  issues: string[],
): void {
  if (value === undefined) {
    return;
  }
  if (!isFiniteNumber(value)) {
    issues.push(`${path} must be a finite number.`);
  }
}

export function assertPositiveInteger(
  value: number | undefined,
  path: string,
  issues: string[],
): void {
  if (value === undefined) {
    return;
  }

  if (!Number.isInteger(value) || value <= 0) {
    issues.push(`${path} must be a positive integer.`);
  }
}
